import { Button, Flex, Image, Input, TableProps } from "antd";
import { useParams, useSearchParams } from "react-router-dom";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import placeholder from "../../../../assets/images/avatar.svg";
import TitleBar from "../../../../components/common/TitleBar";
import CustomTable from "../../../../components/ui/CustomTable";
import {
  useGeneratePayrollMutation,
  useGetKPIBatchDetailsQuery,
} from "../../../../features/organization/contractual/Payroll/payrollApi";
import useError from "../../../../hooks/useError";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import {
  addCommaInNumber,
  countParPageSerialNumber,
} from "../../../../utils/number";
import { valueOrNa } from "../../../../utils/string";
import { addKeyInArray } from "../../../../utils/utils";

const KPIBatchDetails = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const cycle = searchParams.get("cycle");

  const { page, limit, keyword, handleLimit, handleSearch, handlePagination } =
    useTable<any>();

  const { data, isLoading, isFetching } = useGetKPIBatchDetailsQuery(
    {
      args: { params: { search: keyword } },
      id: id as unknown as number,
    },
    { skip: !id }
  );

  const [generatePayroll, { isLoading: generating, isError, error }] =
    useGeneratePayrollMutation();

  const handleGeneratePayroll = () => {
    if (!id) return null;
    generatePayroll({ kpi_batch_ids: [id] });
  };

  useError(isError, error, "Payroll generate failed.");

  const columns: TableProps<any>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Bondhu Name",
      dataIndex: "member_name",
      render: (val) => (
        <Flex align="center" gap={6}>
          <Image
            width={38}
            height={38}
            src={placeholder}
            className="rounded-full"
          />
          <span>{valueOrNa(val)}</span>
        </Flex>
      ),
    },
    {
      title: "Bondhu ID",
      dataIndex: "employee_id",
      render: (val) => valueOrNa(val),
    },

    {
      title: "Slab Name",
      dataIndex: "salary_slab",
      render: (val) => valueOrNa(val?.slab_name),
    },
    {
      title: "Base Salary",
      dataIndex: "salary_slab",
      render: (val) => `৳${addCommaInNumber(val?.variable_amount || 0)}`,
    },
    {
      title: "KPI Score",
      dataIndex: "total_achievement_score",
      render: (val) => <span>{val ? `${val}%` : "n/a"}</span>,
    },
    {
      title: "Variable",
      dataIndex: "salary_slab",
      render: (val) => `৳${addCommaInNumber(val?.variable_amount || 0)}`,
    },
    {
      title: "Net Pay",
      dataIndex: "salary_slab",
      render: (val) => `৳${addCommaInNumber(val?.total_salary || 0)}`,
    },
  ];

  return (
    <SidebarLayout title="Payroll">
      <TitleBar
        backLink="/organization/contractual/payroll"
        title={cycle as string}
      >
        {status === "pending" && (
          <Button
            loading={generating}
            onClick={handleGeneratePayroll}
            type="primary"
          >
            Generate Payroll
          </Button>
        )}
      </TitleBar>
      <CustomTable
        page={page}
        limit={limit}
        columns={columns}
        total={data?.data.total}
        loading={isLoading || isFetching}
        dataSource={addKeyInArray(data?.data.members)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        filterSection={
          <>
            <Input
              suffix={<SearchIcon />}
              placeholder="Search by employee"
              style={{ minWidth: 170, maxWidth: 180 }}
              onChange={(val) => handleSearch(val)}
            />
          </>
        }
      />
    </SidebarLayout>
  );
};

export default KPIBatchDetails;
